import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { DevicesStatus } from 'src/features/parkingStatus/types';

const RESOURCE = '/parkings/:parkingId/devices/status/';

interface DTO {
    parkingId: string;
}

type QueryFnType = typeof queryFn;
const queryFn = ({ parkingId }: DTO): Promise<DevicesStatus> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...params }: UseQueryHookOptions) => {
    return useQuery({
        queryKey: [RESOURCE, params],
        queryFn: async () => await queryFn(params),
        ...config,
    });
};

export { RESOURCE as GET_DEVICES_STATUS_RESOURCE, queryFn as getDevicesStatus, useQueryHook as useGetDevicesStatus };
export type { DTO as GetDevicesStatusDTO };
